import { Routes } from '@angular/router';
import { NotFoundComponent } from './not-found.component';

export const APP_ROUTES: Routes = [
  { path: 'poll/:id', loadChildren: () => import('./home/home.module').then(m => m.HomeModule) },
  { path: 'feed', loadChildren: () => import('./feed/feed.module').then(m => m.FeedModule) },
  { path: 'feed/:categoryName', loadChildren: () => import('./feed/feed.module').then(m => m.FeedModule) },

  { path: 'profile/:id', loadChildren: () => import('./profile/profile.module').then(m => m.ProfileModule) },
  { path: 'username/:id', loadChildren: () => import('./profile/profile.module').then(m => m.ProfileModule) },

  { path: 'vibetribe-profile/:id', loadChildren: () => import('./profile/profile.module').then(m => m.ProfileModule) },
  
  // { path: 'hot-takes/:id', loadChildren: () => import('./hot-takes/hot-takes.module').then(m => m.HotTakesModule)},
  // { path: 'insights/:id', loadChildren: () => import('./insights/insights.module').then(m => m.InsightsModule)},
  { path: 'comment/:id/:commentid', loadChildren: () => import('./comment/comment.module').then(m => m.FeedFetailsModule) },
  { path: 'circles/:type/:id/:userUid', loadChildren: () => import('./circles/circles.module').then(m => m.CirclesModule) },
  { path: 'account-deletion', loadChildren: () => import('./account-deletion-form/account-deletion-form.module').then(m => m.AccountDeletionFormModule) },
  { path: '**', component: NotFoundComponent }
];
